'use strict';
module.exports = {};



// WEBPACK FOOTER //
// ./~/core-js/internals/iterators.js